import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { PLANS_QUERY_KEYS } from "../queryKeys";
import { getWebSubscriptionPlans } from "../services/webSubscriptionPlan";

export const useGetWebSubscriptionPlans = () => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: [...PLANS_QUERY_KEYS.WEB_SUBSCRIPTION_PLANS, i18n.language],
    queryFn: getWebSubscriptionPlans,
  });
};
